<template lang="pug">
    .h-100.w-100.center-xy
      img.icon.mb-5(src="@/assets/images/branding/logo_dark.svg")
      // h2 Artist Panel
      b-button.btn-outline#btnGoToLogin(:to="{name: 'Login'}") ARTIST LOGIN
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue